module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/id/5/2-675a9be67e3785cdffc6d5eb4773934e.jpg";